import React from 'react';
import { components } from 'react-select';
import { WpTooltip, WpTooltipContent, WpTooltipTrigger } from 'Wpds/components/tooltip';

type Props = {
  data: {
    value: 'string';
  };
};

function MultiValueContainer(props: Props) {
  return (
    <WpTooltip>
      <WpTooltipTrigger>
        <div style={{ maxWidth: '45%' }}>
          <components.MultiValueContainer {...props} />
        </div>
      </WpTooltipTrigger>
      <WpTooltipContent>{props.data.value}</WpTooltipContent>
    </WpTooltip>
  );
}

export default MultiValueContainer;
